import { render, staticRenderFns } from "./RequEdit.vue?vue&type=template&id=4f902dd0&scoped=true&"
import script from "./RequEdit.vue?vue&type=script&lang=js&"
export * from "./RequEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f902dd0",
  null
  
)

export default component.exports